import { Breakpoints } from '~/styles/media';
import useBreakpoint from './useBreakpoint';

const useIsMobile = () => {
  const breakpoint = useBreakpoint();
  return breakpoint === Breakpoints.mobile;
};

export default useIsMobile;
